<template>
  <div id="device_tab"
       class="main-tab main-tab-o">
    <div class="dv-content-device">
      <img src="../assets/images/icon_de_bg.png"
           class="img-dv-bg">
      <img src="../assets/images/icon_de_bg_bottom.png"
           class="img-zj-bg-bottoms">
      <div class="dv-content-de-s">
        <div class="tv-title">引领医疗科技 致力天下安康</div>
        <div class="dv-content-items">
          <div class="dv-white"></div>
          <div class="dv-item-photo"
               v-for="(item,index) in devicelists"
               v-bind:key="index">
            <el-image :src="item.fileUrl"
                      class="img-photo"
                      fit="contain"></el-image>
            <span class="tv-de-name">{{ item.title }}</span>
          </div>

        </div>
      </div>
    </div>

  </div>

</template>

<script>
import api from '../api/api'
export default {
  data () {
    return {
      devicelists: [],//医疗设备列表
    }
  },
  created () {
    //医疗设备列表
    this.devicelist()
  },
  methods: {
    //医疗设备列表
    devicelist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 1000,

      }
      api.devicelist(parm).then((res) => {
        this.devicelists = res.data.list

      })
    },
  }

}
</script>

<style>
.dv-content-device {
  width: 100%;
  height: fit-content;
  display: flex;
  position: relative;
  flex-direction: column;
}
.img-dv-bg {
  position: absolute;
  /* top: 40px; */
  left: 0;
  width: 100%;
}
.dv-content-de-s {
  width: calc(100% - 600px);
  height: fit-content;
  margin-left: 300px;
  margin-top: 40px;
  height: fit-content;
  display: flex;
  flex-direction: column;
}
.tv-title {
  font-size: 28px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  margin-top: 100px;
  color: #ffffff;
}
.dv-content-items {
  width: 100%;
  /* background: white; */
  height: fit-content;
  margin-top: 50px;
  display: flex;
  flex-direction: row;
  position: relative;
  min-height: 800px;
  flex-flow: row wrap;
  margin-bottom: 200px;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.dv-item-photo {
  width: calc(25% - 25px);
  margin-left: 20px;
  height: fit-content;
  margin-bottom: 40px;
  display: flex;
  margin-top: 20px;
  flex-direction: column;
}
.img-photo {
  width: 100%;
  height: 400px;
  background: #edf0f8;
}
.tv-de-name {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #333333;
  margin-top: 10px;
}
.img-zj-bg-bottoms {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
.dv-white {
  position: absolute;
  width: 100%;
  height: 100px;
  background: white;
  top: 0;
  left: 0;
}
</style>